import { lazy, Suspense } from "react";
import { PATHS } from "@/lib/router";
import { RouteLoading } from "@/components/common";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const CreateSurveyPage = lazy(() => import("./pages/CreateSurveyPage"));
const QuestionLibraryPage = lazy(() => import("./pages/QuestionLibraryPage"));
const TakeSurveyPage = lazy(() => import("./pages/TakeSurveyPage"));
const SurveyLibraryPage = lazy(() => import("./pages/SurveyLibraryPage"));
const SurveyResponsesPage = lazy(() => import("./pages/SurveyResponsesPage"));
const ResponsesDetailPage = lazy(() => import("./pages/ResponsesDetailPage"));
const GuestContactPage = lazy(() => import("./pages/GuestContactPage"));
const SurveyDashboardPage = lazy(() => import("./pages/SurveyDashboardPage"));

export const surveyManagementRoutes = [
  {
    path: PATHS.SURVEY_LIBRARY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <SurveyLibraryPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_library", action: "view" },
    },
  },
  {
    path: PATHS.QUESTION_LIBRARY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <QuestionLibraryPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "question_library", action: "view" },
    },
  },
  {
    path: PATHS.SURVEY_RESPONSES,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <SurveyResponsesPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_responses", action: "view" },
    },
  },
  {
    path: PATHS.RESPONSES_DETAIL,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <ResponsesDetailPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_responses", action: "view" },
    },
  },
  {
    path: PATHS.CREATE_NEW_SURVEY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <CreateSurveyPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_library", action: "create" },
    },
  },
  {
    path: PATHS.GUEST_CONTACTS,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <GuestContactPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "guest_contacts", action: "view" },
    },
  },
  {
    path: PATHS.SURVEY_DASHBOARD,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <SurveyDashboardPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_dashboard", action: "view" },
    },
  },
  {
    path: PATHS.EDIT_SURVEY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <CreateSurveyPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "survey_library", action: "create" },
    },
  },
];

export const surveyLibraryPublicRoutes = [
  {
    path: PATHS.TAKE_SURVEY,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SURVEY_MANAGEMENT}>
        <Suspense fallback={<RouteLoading />}>
          <TakeSurveyPage />
        </Suspense>
      </FeatureProvider>
    ),
  },
];
